import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll'
import './style.css'

const Scrollbar = () => {

    return (
        <ul className="smothscroll">
            <li>
                <AnchorLink href='#scrool' aria-label="Back to top">
                    <i className="far fa-arrow-up" aria-hidden="true"></i>
                    <span className="sr-only">Back to top</span>
                </AnchorLink>
            </li>
        </ul>
    )
}

export default Scrollbar;
